import { Validator } from '@vista-digital/validator';
import { NumberInputType } from '../../../../subcomponents/form/input/number/types/type';
export const defaultTicketPickerConfig = {
    quantityInputType: NumberInputType.Spinner,
    showBookingFees: true,
    displayErrorsInline: true
};
export const ticketPickerConfigValidator = Validator.object({
    quantityInputType: Validator.oneOf(Object.values(NumberInputType)),
    showBookingFees: Validator.boolean(),
    displayErrorsInline: Validator.boolean()
});
